var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buyerShop"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v("完成度初始化")]),_c('div',{staticClass:"mt20"},[_vm._v(_vm._s(_vm.result))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }